module.exports = __webpack_public_path__ + "static/media/captainfalcon_0.fc739e3a.png";